import React, { useContext, useRef, useState } from "react";
import classNames from "classnames";
import { CoachMarkerContext } from "./CoachMarkerContext";

export enum CoachMarkerStepPosition {
    Bottom,
    BottomRight,
    BottomLeft,
    Right,
}

interface ICoachMarkerStepProps {
    coachMarkerKey: string;
    cssWrapper?: string;
}

const CoachMarker = (props: ICoachMarkerStepProps) => {
    const { coachMarkerKey, cssWrapper } = props;
    const [display, setDisplay] = useState(false);
    const coachMarkContext = useContext(CoachMarkerContext);
    const contentRef = useRef(null);
    const step = coachMarkContext?.step;

    const onKeyPress = (ev: KeyboardEvent) => {
        if (ev.key == "Escape") {coachMarkContext.onClickDoNotShow();}
    };

    const wrapperClasses = classNames(
        "coach-marker-wrapper",
        "ad",
        cssWrapper,
        { "to-the-bottom": step?.stepPosition == CoachMarkerStepPosition.Bottom },
        { "to-the-left-bottom": step?.stepPosition == CoachMarkerStepPosition.BottomRight },
        { "to-the-right-bottom": step?.stepPosition == CoachMarkerStepPosition.BottomLeft }
    );

    React.useEffect(() => {
        if (coachMarkContext?.step?.stepKey === coachMarkerKey && coachMarkContext.showCoachMarks) {
            setDisplay(true);
        } else {
            setDisplay(false);
        }
    }, [coachMarkContext]);

    React.useEffect(() => {
        if (display) {
            const rect = contentRef.current.getBoundingClientRect();
            if (rect.top < 0 || rect.top + rect.height > window.innerHeight) {
                contentRef.current.scrollIntoView({ block: "center" });
            }
        }
    }, [display]);

    React.useEffect(() => {
        window.addEventListener("keydown", onKeyPress);
        return () => {
            window.removeEventListener("keydown", onKeyPress);
        };
    }, []);

    return step && display ? (
        <div className={wrapperClasses} style={{ position: "absolute" }}>
            <div
                className="cm-content"
                role="dialog"
                aria-labelledby="cmTitle"
                aria-describedby="cmContent"
                tabIndex={-1}
                style={{ top: step.positionTop || 0 + "px", left: step.positionLeft || 0 + "px" }}
                ref={contentRef}
            >
                <div className="cm-content-ar1" aria-hidden={true} />
                <div className="cm-content-panel">
                    <div className="row">
                        <div className="col-fluid">
                            <p id="cmTitle" className="title">
                                {step.title}
                            </p>
                        </div>
                        <div className="col-auto">
                            <div className="">{coachMarkContext.dotBarDots}</div>
                        </div>
                    </div>
                    <div id="cmContent" className="mb-10">
                        {coachMarkContext.step.description}
                    </div>
                    <div className="row">
                        <div className="col-fluid col-bottom">
                            <button
                                className="cm-close-button"
                                onClick={(e) => {
                                    e.stopPropagation();
                                    coachMarkContext.onClickDoNotShow();
                                }}
                            >
                                <span>Don't show me tips right now</span>
                            </button>
                        </div>
                        <div className="col-auto">
                            <button
                                className="btn cm-next-button"
                                onClick={(ev) => {
                                    ev.stopPropagation();
                                    coachMarkContext.nextStep();
                                }}
                            >
                                <span>{coachMarkContext.buttonText}</span>
                            </button>
                        </div>
                    </div>
                </div>
                <div className="cm-content-ar2" aria-hidden={true} />
            </div>
        </div>
    ) : null;
};

export default CoachMarker;
